import request from "@/http/request"
import {
    selectPayInfo,
    cashierInfo,
    paymentPretreatment,
    getTenantPayType
} from '@/http/api'
export const getTenantPayTypeApi = (data) => {
    return request({
        url: getTenantPayType,
        data
    })
}
export const selectPayInfoFn = (data) => {
    return request({
        url: selectPayInfo,
        data
    })
}
export const beforePayFn = (data) => {
    return request({
        url: paymentPretreatment,
        data
    })
}

export const payFn = (data) => {
    return request({
        url: cashierInfo,
        data
    })
}